const endpoints = {
	addItemsAssociations: '/item_associations/addItemsAssociations',
	removeItemsAssociations: '/item_associations/removeItemsAssociations',
}
export {endpoints}